import { AMSFilamentSettingCommand } from "./commands/AMSFilamentSettingCommand"
import { AMSControlCommand } from "./commands/AMSControlCommand"

export * from "./commands"
export * from "./responses"
export * from "./types"
export * from "./Job"
export * from "./BambuClient"
export * from "./BambuClientEvents"

// Re-export enums and values
export { Fan } from "./commands/UpdateFanCommand"
export { SpeedLevel } from "./responses/print/PushAllResponse"
export { TempUpdatePartType } from "./commands/UpdateTempCommand"
export { AMSFilamentSettingCommand } from "./commands/AMSFilamentSettingCommand"
export { AMSControlCommand, AMSControlAction } from "./commands/AMSControlCommand"

// Re-export types
export type { UpdateLightLoopOptions } from "./commands/UpdateLightCommand"
export type { LightReport } from "./responses/print/PushAllResponse"
export type { CommandInterface } from "./commands/CommandInterface"
export type { NumberRange } from "./types"
export type { State } from './commands/UpdateStateCommand'

// Re-export constants
export const EXTERNAL_SPOOL_AMS_ID = AMSFilamentSettingCommand.EXTERNAL_SPOOL_AMS_ID;
export const VIRTUAL_TRAY_ID = AMSFilamentSettingCommand.VIRTUAL_TRAY_ID;
